import React, { useEffect } from "react";
import {
  ABOUT_AUTHOR,
  H2_ABOUT_IMG01,
  H2_ABOUT_IMG02,
  SIGNATURE,
} from "../../lib/assets";
import aboutShapeHearts from "../../assets/img/about-three/hearts.png";
import aboutShapeLining from "../../assets/img/about-three/lining.png";
import aboutShapeSquares from "../../assets/img/about-three/squares.png";
import bookkeepingImg from "../../assets/img/about-three/bookkeeping_img.png";
import monthlyReportingImg from "../../assets/img/about-three/monthly_review_1.png";

export const AboutThree = () => {
  const list = [
    "Every sale and expense recorded",
    "Bank and credit cards reconciled monthly",
    "Receipts organized and stored digitally",
    "A simple monthly report on where your money went",
  ];

  return (
    <section className="about-area-three">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 col-md-9">
            <div className="about-img-wrap-three">
              <img
                src={bookkeepingImg}
                alt=""
                data-aos="fade-down-right"
                data-aos-delay="0"
              />
              <img
                src={monthlyReportingImg}
                alt=""
                data-aos="fade-left"
                data-aos-delay="400"
              />
              <div
                className="experience-wrap"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <h2 className="title">
                  X <span>Years</span>
                </h2>
                <p>Of hands-on booking and accounting experience.</p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="about-content-three">
              <div className="section-title-two mb-20 tg-heading-subheading animation-style3">
                <span className="sub-title">Bookkeeping Made Simple</span>
                <h2 className="title tg-element-title">
                What Is Bookkeeping, and Do You Need It From Day One?
                </h2>
              </div>
              <p className="info-one">
              Bookkeeping means recording every dollar that comes in and goes out of your business, then matching it to your bank statements each month. Yes, you need it from day one: the CRA expects businesses to keep records for at least six years, and clean books make tax time faster and cheaper.
              </p>

              <div className="about-list-two">
                <ul className="list-wrap">
                  {list.map((item, idx) => (
                    <li key={idx}>
                      <i className="fas fa-arrow-right"></i> {item}
                    </li>
                  ))}
                </ul>
              </div>
              <p>
              Silverwave is a local bookkeeping practice for startups and 
              small businesses in Surrey, Delta, Langley and White Rock.
              </p>
              {/* <div className="about-author-info">
                <div className="thumb">
                  <img src={ABOUT_AUTHOR} alt="" />
                </div>
                <div className="content">
                  <h2 className="title">Mark Stranger</h2>
                  <span>CEO, Gerow Finance</span>
                </div>
                <div className="signature">
                  <img src={SIGNATURE} alt="" />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="about-shape-wrap-two">
        <img src={aboutShapeHearts} alt="" />
        <img src={aboutShapeLining} alt="" />
        <img
          src={aboutShapeSquares}
          alt=""
          data-aos="fade-left"
          data-aos-delay="500"
        />
      </div>
    </section>
  );
};
